<template>
  <v-tooltip top>
    <template #activator="{ on }">
      <v-btn v-bind="$attrs" icon v-on="on" @click="$emit('click', $event)">
        <v-icon>
          {{ icon }}
        </v-icon>
      </v-btn>
    </template>
    <slot />
  </v-tooltip>
</template>
<script>
export default {
  props: {
    icon: {
      type: String,
      default: "mdi-pencil",
    },
  },
  inheritAttrs: false,
};
</script>
